
jQuery(function($) {

    console.log('line script running...');

    $(document).ready(function() {

        window.SLIDECART_UPDATED = function(cart) {
            console.log('CART UPDATED');
            $(document).find('#slidecarthq footer form').remove();
            if ($(document).find('.c-me-out').length == 0) {
                $('<button class="button full c-me-out" data-loading="Please wait..." data-normal="Checkout">Checkout</button>').insertBefore($(document).find('#slidecarthq footer .footer-continue'));
            }
        }


        $(document).on('click', '.c-me-out', function(e) {

            e.preventDefault();
            //console.log('c me out clicked!!');

            $(this).text($(this).attr('data-loading'));
            $(this).attr('disabled', 'disabled');
		  
		  	var _this = $(this);

            var cartContents = fetch('/cart.js').then(response=>response.json()).then(data=>{
                //console.log(data);
                var subscription = false;
                $.each(data.items, function(i, item) {
                    //console.log(item.properties.shipping_interval_frequency);
                    if (item.properties.shipping_interval_frequency && item.properties.shipping_interval_unit_type) {
                        subscription = true;
                        return false;
                    }
                });

                var url = '/checkout';

                if (subscription == true) {
                    let paramCustomer = ''
                    let paramCart = '&cart_token=' + data.token;
                    let paramDomain = 'myshopify_domain=upwellnessmain.myshopify.com';

                    if (window.SLIDECART_CUSTOMER_ID && window.SLIDECART_CUSTOMER_EMAIL) {
                        paramCustomer = `&customer_id=${window.SLIDECART_CUSTOMER_ID}&customer_email=${window.SLIDECART_CUSTOMER_EMAIL}`
                    }

                    try {
                        var paramLinker = '&' + ga.getAll()[0].get('linkerParam')
                    } catch (err) {
                        var paramLinker = ''
                    }

                    url = 'https://checkout.rechargeapps.com/r/checkout?' + paramDomain + paramCart + paramLinker + paramCustomer;

                }

               window.location = url;
               //console.log(url);
            }
            ).catch(function(error){
			  console.log('ERROR:', error);
               _this.text($(this).attr('data-normal'));
               _this.removeAttr('disabled');
			});

        });

    });

});